import { useState } from "react";

import type { DeleteRoleDialogProps, DeleteRoleDialogViewModel } from "./types-delete-role-dialog";

/** RN01 (HU 870): enquanto a requisição não volta o botão fica bloqueado, e uma confirmação envia uma só requisição. */
export function useDeleteRoleDialog({
  role,
  onConfirm,
  onCancel,
}: DeleteRoleDialogProps): DeleteRoleDialogViewModel {
  const [isDeleting, setIsDeleting] = useState(false);

  async function confirmar() {
    if (isDeleting) return;

    setIsDeleting(true);
    try {
      await onConfirm();
    } finally {
      setIsDeleting(false);
    }
  }

  return { role, isDeleting, confirmar: () => void confirmar(), cancelar: onCancel };
}
